<template>
  <div>
    <main class="main reception">
      <div class="section call-guidance">
        <div class="call-guidance--rectangle">
          <h4>
              본인인증이 완료되었습니다.
            <br />확인버튼을 눌러주세요
          </h4>
        </div>
      </div>
      <div class="section bottom">
        <button
          v-ripple
          class="button next-button"
          type="button"
          @click="confirm"
        >확인</button>
      </div>
    </main>
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'
import UserService from '@/service/user/UserService'

export default {
  data() {
    return {
    }
  },
  async created() {
    this.$store.commit('ui/headerTitle', '본인인증 확인하기')
  },
  methods: {
    async confirm() {
      let isExistingCustomer = await UserService.isExistingCustomer()
      await AuthService.syncProfile()
      if (isExistingCustomer) {
        this.$router.push({ name: 'kyc/verify-id-card' })
      } else {
        await this.$router.push({ name: 'factoring/confirm' })
      }
    }
  }
}
</script>
<style scoped>
  .call-guidance--rectangle {
     text-align: center;
  }
</style>
